module.exports = __webpack_public_path__ + "img/Q&A.f6ec75ac.svg";